import { render } from "./ContactsViewCtrl.vue?vue&type=template&id=753e2384&scoped=true"
import script from "./ContactsViewCtrl.vue?vue&type=script&lang=js"
export * from "./ContactsViewCtrl.vue?vue&type=script&lang=js"

import "./ContactsViewCtrl.vue?vue&type=style&index=0&id=753e2384&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753e2384"]])

export default __exports__